import * as d from "protobufjs/minimal.js";
import "../billing/data.js";
import "../common/countries.js";
import "long";
import "../common/currency_codes.js";
import "../common/time.js";
import "../precog/v2/common.js";
import { Pricing as l, Duration as f, ActivationSource as s, Feedback as c, Subscription as p } from "./data.js";
import "./common.js";
const r = "default" in d ? d.default : d;
var b;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.AGGREGATED = 1] = "AGGREGATED", e[e.DISCRETE = 2] = "DISCRETE";
})(b || (b = {}));
var k;
(function(e) {
  e[e.INCREMENT = 0] = "INCREMENT", e[e.DECREMENT = 1] = "DECREMENT", e[e.SET = 2] = "SET";
})(k || (k = {}));
var T;
(function(e) {
  e[e.DEFAULT = 0] = "DEFAULT", e[e.FREE_TRIAL = 1] = "FREE_TRIAL", e[e.FREE_TRIAL_NO_OBLIGATION = 2] = "FREE_TRIAL_NO_OBLIGATION", e[e.ACTIVE = 3] = "ACTIVE", e[e.PRESALE = 4] = "PRESALE";
})(T || (T = {}));
var E;
(function(e) {
  e[e.DO_NOT_USE_UI = 0] = "DO_NOT_USE_UI", e[e.FULL_PAGE_PAYWALL = 1] = "FULL_PAGE_PAYWALL", e[e.MODAL = 2] = "MODAL", e[e.PAYWALL_CARD = 3] = "PAYWALL_CARD", e[e.DOWNGRADE = 4] = "DOWNGRADE", e[e.TRIAL_WELCOME = 5] = "TRIAL_WELCOME", e[e.TRIAL_EXPIRING = 6] = "TRIAL_EXPIRING", e[e.TRIAL_EXPIRED = 7] = "TRIAL_EXPIRED";
})(E || (E = {}));
function P() {
  return { $type: "squareup.sub2.service.ListFeatureStatusesResponse", featureStatuses: [] };
}
const R = {
  $type: "squareup.sub2.service.ListFeatureStatusesResponse",
  encode(e, n = r.Writer.create()) {
    for (const i of e.featureStatuses)
      o.encode(i, n.uint32(10).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const i = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = n === void 0 ? i.len : i.pos + n;
    const t = P();
    for (; i.pos < u; ) {
      const a = i.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          t.featureStatuses.push(o.decode(i, i.uint32()));
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      i.skipType(a & 7);
    }
    return t;
  },
  create(e) {
    return R.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var i;
    const n = P();
    return n.featureStatuses = ((i = e.featureStatuses) == null ? void 0 : i.map((u) => o.fromPartial(u))) || [], n;
  }
};
function m() {
  return {
    $type: "squareup.sub2.service.ListFeatureStatusesResponse.FeatureStatus",
    feature: void 0,
    status: void 0,
    subscriptionToken: void 0
  };
}
const o = {
  $type: "squareup.sub2.service.ListFeatureStatusesResponse.FeatureStatus",
  encode(e, n = r.Writer.create()) {
    return e.feature !== void 0 && n.uint32(8).int32(e.feature), e.status !== void 0 && n.uint32(16).int32(e.status), e.subscriptionToken !== void 0 && n.uint32(26).string(e.subscriptionToken), n;
  },
  decode(e, n) {
    const i = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = n === void 0 ? i.len : i.pos + n;
    const t = m();
    for (; i.pos < u; ) {
      const a = i.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 8)
            break;
          t.feature = i.int32();
          continue;
        case 2:
          if (a !== 16)
            break;
          t.status = i.int32();
          continue;
        case 3:
          if (a !== 26)
            break;
          t.subscriptionToken = i.string();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      i.skipType(a & 7);
    }
    return t;
  },
  create(e) {
    return o.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = m();
    return n.feature = e.feature ?? void 0, n.status = e.status ?? void 0, n.subscriptionToken = e.subscriptionToken ?? void 0, n;
  }
};
function C() {
  return {
    $type: "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CreateSubscription",
    planToken: void 0,
    customPricing: void 0,
    sendEmail: void 0,
    startInFreeTrialNoObligationState: void 0,
    customFreeTrialDuration: void 0,
    planBillingCycle: void 0,
    activationSource: void 0
  };
}
const L = {
  $type: "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CreateSubscription",
  encode(e, n = r.Writer.create()) {
    return e.planToken !== void 0 && n.uint32(10).string(e.planToken), e.customPricing !== void 0 && l.encode(e.customPricing, n.uint32(18).fork()).ldelim(), e.sendEmail !== void 0 && n.uint32(24).bool(e.sendEmail), e.startInFreeTrialNoObligationState !== void 0 && n.uint32(32).bool(e.startInFreeTrialNoObligationState), e.customFreeTrialDuration !== void 0 && f.encode(e.customFreeTrialDuration, n.uint32(42).fork()).ldelim(), e.planBillingCycle !== void 0 && n.uint32(48).int32(e.planBillingCycle), e.activationSource !== void 0 && s.encode(e.activationSource, n.uint32(58).fork()).ldelim(), n;
  },
  decode(e, n) {
    const i = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = n === void 0 ? i.len : i.pos + n;
    const t = C();
    for (; i.pos < u; ) {
      const a = i.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          t.planToken = i.string();
          continue;
        case 2:
          if (a !== 18)
            break;
          t.customPricing = l.decode(i, i.uint32());
          continue;
        case 3:
          if (a !== 24)
            break;
          t.sendEmail = i.bool();
          continue;
        case 4:
          if (a !== 32)
            break;
          t.startInFreeTrialNoObligationState = i.bool();
          continue;
        case 5:
          if (a !== 42)
            break;
          t.customFreeTrialDuration = f.decode(i, i.uint32());
          continue;
        case 6:
          if (a !== 48)
            break;
          t.planBillingCycle = i.int32();
          continue;
        case 7:
          if (a !== 58)
            break;
          t.activationSource = s.decode(i, i.uint32());
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      i.skipType(a & 7);
    }
    return t;
  },
  create(e) {
    return L.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = C();
    return n.planToken = e.planToken ?? void 0, n.customPricing = e.customPricing !== void 0 && e.customPricing !== null ? l.fromPartial(e.customPricing) : void 0, n.sendEmail = e.sendEmail ?? void 0, n.startInFreeTrialNoObligationState = e.startInFreeTrialNoObligationState ?? void 0, n.customFreeTrialDuration = e.customFreeTrialDuration !== void 0 && e.customFreeTrialDuration !== null ? f.fromPartial(e.customFreeTrialDuration) : void 0, n.planBillingCycle = e.planBillingCycle ?? void 0, n.activationSource = e.activationSource !== void 0 && e.activationSource !== null ? s.fromPartial(e.activationSource) : void 0, n;
  }
};
function F() {
  return {
    $type: "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CancelSubscription",
    subscriptionToken: void 0,
    cancelImmediately: void 0,
    sendEmail: void 0,
    feedback: []
  };
}
const D = {
  $type: "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CancelSubscription",
  encode(e, n = r.Writer.create()) {
    e.subscriptionToken !== void 0 && n.uint32(10).string(e.subscriptionToken), e.cancelImmediately !== void 0 && n.uint32(16).bool(e.cancelImmediately), e.sendEmail !== void 0 && n.uint32(32).bool(e.sendEmail);
    for (const i of e.feedback)
      c.encode(i, n.uint32(42).fork()).ldelim();
    return n;
  },
  decode(e, n) {
    const i = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = n === void 0 ? i.len : i.pos + n;
    const t = F();
    for (; i.pos < u; ) {
      const a = i.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          t.subscriptionToken = i.string();
          continue;
        case 2:
          if (a !== 16)
            break;
          t.cancelImmediately = i.bool();
          continue;
        case 4:
          if (a !== 32)
            break;
          t.sendEmail = i.bool();
          continue;
        case 5:
          if (a !== 42)
            break;
          t.feedback.push(c.decode(i, i.uint32()));
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      i.skipType(a & 7);
    }
    return t;
  },
  create(e) {
    return D.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var i;
    const n = F();
    return n.subscriptionToken = e.subscriptionToken ?? void 0, n.cancelImmediately = e.cancelImmediately ?? void 0, n.sendEmail = e.sendEmail ?? void 0, n.feedback = ((i = e.feedback) == null ? void 0 : i.map((u) => c.fromPartial(u))) || [], n;
  }
};
function S() {
  return {
    $type: "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.UpdateSubscription",
    subscription: void 0,
    cancelFutureDowngrade: void 0,
    startInFreeTrialNoObligationState: void 0,
    feedback: [],
    sendEmail: void 0
  };
}
const y = {
  $type: "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.UpdateSubscription",
  encode(e, n = r.Writer.create()) {
    e.subscription !== void 0 && p.encode(e.subscription, n.uint32(10).fork()).ldelim(), e.cancelFutureDowngrade !== void 0 && n.uint32(16).bool(e.cancelFutureDowngrade), e.startInFreeTrialNoObligationState !== void 0 && n.uint32(24).bool(e.startInFreeTrialNoObligationState);
    for (const i of e.feedback)
      c.encode(i, n.uint32(42).fork()).ldelim();
    return e.sendEmail !== void 0 && n.uint32(48).bool(e.sendEmail), n;
  },
  decode(e, n) {
    const i = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = n === void 0 ? i.len : i.pos + n;
    const t = S();
    for (; i.pos < u; ) {
      const a = i.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          t.subscription = p.decode(i, i.uint32());
          continue;
        case 2:
          if (a !== 16)
            break;
          t.cancelFutureDowngrade = i.bool();
          continue;
        case 3:
          if (a !== 24)
            break;
          t.startInFreeTrialNoObligationState = i.bool();
          continue;
        case 5:
          if (a !== 42)
            break;
          t.feedback.push(c.decode(i, i.uint32()));
          continue;
        case 6:
          if (a !== 48)
            break;
          t.sendEmail = i.bool();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      i.skipType(a & 7);
    }
    return t;
  },
  create(e) {
    return y.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var i;
    const n = S();
    return n.subscription = e.subscription !== void 0 && e.subscription !== null ? p.fromPartial(e.subscription) : void 0, n.cancelFutureDowngrade = e.cancelFutureDowngrade ?? void 0, n.startInFreeTrialNoObligationState = e.startInFreeTrialNoObligationState ?? void 0, n.feedback = ((i = e.feedback) == null ? void 0 : i.map((u) => c.fromPartial(u))) || [], n.sendEmail = e.sendEmail ?? void 0, n;
  }
};
function I() {
  return {
    $type: "squareup.sub2.service.BulkGetFeatureDiffRequest.PlanChange",
    currentPlanToken: void 0,
    currentPlanBillingCycle: void 0,
    newPlanToken: void 0,
    newPlanBillingCycle: void 0
  };
}
const B = {
  $type: "squareup.sub2.service.BulkGetFeatureDiffRequest.PlanChange",
  encode(e, n = r.Writer.create()) {
    return e.currentPlanToken !== void 0 && n.uint32(10).string(e.currentPlanToken), e.currentPlanBillingCycle !== void 0 && n.uint32(16).int32(e.currentPlanBillingCycle), e.newPlanToken !== void 0 && n.uint32(26).string(e.newPlanToken), e.newPlanBillingCycle !== void 0 && n.uint32(32).int32(e.newPlanBillingCycle), n;
  },
  decode(e, n) {
    const i = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = n === void 0 ? i.len : i.pos + n;
    const t = I();
    for (; i.pos < u; ) {
      const a = i.uint32();
      switch (a >>> 3) {
        case 1:
          if (a !== 10)
            break;
          t.currentPlanToken = i.string();
          continue;
        case 2:
          if (a !== 16)
            break;
          t.currentPlanBillingCycle = i.int32();
          continue;
        case 3:
          if (a !== 26)
            break;
          t.newPlanToken = i.string();
          continue;
        case 4:
          if (a !== 32)
            break;
          t.newPlanBillingCycle = i.int32();
          continue;
      }
      if ((a & 7) === 4 || a === 0)
        break;
      i.skipType(a & 7);
    }
    return t;
  },
  create(e) {
    return B.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = I();
    return n.currentPlanToken = e.currentPlanToken ?? void 0, n.currentPlanBillingCycle = e.currentPlanBillingCycle ?? void 0, n.newPlanToken = e.newPlanToken ?? void 0, n.newPlanBillingCycle = e.newPlanBillingCycle ?? void 0, n;
  }
};
export {
  D as BatchCreateAndCancelSubscriptionsRequest_CancelSubscription,
  L as BatchCreateAndCancelSubscriptionsRequest_CreateSubscription,
  y as BatchCreateAndCancelSubscriptionsRequest_UpdateSubscription,
  T as BulkCreateSubscriptionsRequest_StartingStatus,
  B as BulkGetFeatureDiffRequest_PlanChange,
  E as GetUiAssetsRequest_Ui,
  R as ListFeatureStatusesResponse,
  o as ListFeatureStatusesResponse_FeatureStatus,
  b as UsageActionType,
  k as UsageMode
};
